import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactResizeDetector from 'react-resize-detector';
import { Nav, MenuItem, NavDropdown } from 'react-bootstrap';
import { first, map, reject, find, each, reduce } from 'lodash';
import { getHeaderHeight } from '../../../App/AppReducer';
import { getWinLossStatsFilters } from '../../DashboardReducer';
import NumberDisplay from '../../../../components/number-display';

import styles from './styles.css';

const MAIN_NAVS = [
  { label: 'All Deals', key: '__ALL__' },
  { label: 'Wins', key: 'won' },
  { label: 'Losses', key: 'lost' },
  { label: 'No Decision', key: 'noDecision' },
];
class WinLossOpportunityTableNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null,
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.onResizeTabs = this.onResizeTabs.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.selected) {
      const { navs } = nextProps;
      const firstNav = first(navs);
      if (firstNav) {
        const firstSubNav = first(firstNav.items);
        if (firstSubNav) {
          this.handleSelect(firstSubNav.key);
          this.setState({ selected: firstSubNav.key });
          this.props.onChange(firstSubNav.params);
        }
      }
    }
  }

  onResizeTabs(width, height) {
    this.props.onHeightChange(height);
  }
  handleSelect(selected) {
    this.setState({ selected });
    const { navs } = this.props;
    let params = null;
    each(navs, (nav) => {
      each(nav.items, (subNav) => {
        if (subNav.key === selected) {
          ({ params } = subNav);
        }
      });
    });
    this.props.onChange(params);
  }

  render() {
    const { 
      hasNoDecision, fullScreenMode, siteHeaderHeight,
      navs,
    } = this.props;
    const { selected } = this.state;


    const allNavs = map(navs, (nav) => {
      let mainLabel = nav.label;
      const subNav = find(nav.items, { key: selected });
      if (subNav) {
        mainLabel = (
          <span>
            {nav.label}: {subNav.label} <span className="badge"><NumberDisplay value={subNav.count} precision={0} /></span>
          </span>
        );
      }
      return {
        ...nav,
        label: mainLabel,
      };
    });
    const navComp = (
      <Nav bsStyle={fullScreenMode ? 'pills' : 'tabs'} activeKey={selected} onSelect={this.handleSelect}>
        {allNavs.map(nav => (
          <NavDropdown
            eventKey={nav.key}
            title={nav.label}
            id={nav.key}
            key={nav.key}
          >
            {nav.items.map(subNav => (
              <MenuItem key={subNav.key} eventKey={subNav.key}>
                <div>
                  <span>{subNav.label}</span> <span className="badge"><NumberDisplay value={subNav.count} precision={0} /></span>
                </div>
              </MenuItem>
              ))}
          </NavDropdown>
        ))}
      </Nav>
    );

    const cls = [];
    const stl = {};
    if (fullScreenMode) {
      cls.push(styles.fullScreenTabs);
      cls.push('animated');
      cls.push('fadeIn');
      stl.top = siteHeaderHeight;
    } else {
      cls.push(styles.nav);
    }

    return (
      <div className={cls.join(' ')} style={stl}>
        {navComp}
        <ReactResizeDetector handleHeight onResize={this.onResizeTabs} />
      </div>
    );
  }
}
WinLossOpportunityTableNav.propTypes = {
  onChange: PropTypes.func,
  hasNoDecision: PropTypes.bool,
  onHeightChange: PropTypes.func,
  fullScreenMode: PropTypes.bool,
  siteHeaderHeight: PropTypes.number,
  navs: PropTypes.arrayOf(PropTypes.shape({})),
};
WinLossOpportunityTableNav.defaultProps = {
  onChange: () => {},
  hasNoDecision: false,
  onHeightChange: () => {},
  fullScreenMode: false,
  siteHeaderHeight: 0,
  navs: [],
};
function mapStateToProps(state, ownProps) {
  const statsFilters = getWinLossStatsFilters(state);
  const { hasNoDecision } = ownProps;
  let allNavs = [];
  if (statsFilters) {
    const allNavRaw = hasNoDecision ? [...MAIN_NAVS] : reject([...MAIN_NAVS], { key: 'noDecision' });
    allNavs = reduce(allNavRaw, (ns, nav) => {
      const items = statsFilters[nav.key] || [];
      nav.items = reduce(items, (subNavs, subNav) => {
        const nSubNav = { 
          ...subNav,
          key: `${nav.key}::${subNav.key}`,
        };
        subNavs.push(nSubNav);
        return subNavs;
      }, []);
      if (nav.items && nav.items.length) {
        ns.push(nav);
      }
      return ns;
    }, []);
  }
  return {
    siteHeaderHeight: getHeaderHeight(state),
    navs: allNavs,
  };
}


export default connect(mapStateToProps)(WinLossOpportunityTableNav);
